import { render, staticRenderFns } from "./SparePartsOrder.vue?vue&type=template&id=2119a5e8"
import script from "./SparePartsOrder.vue?vue&type=script&lang=js"
export * from "./SparePartsOrder.vue?vue&type=script&lang=js"
import style0 from "./SparePartsOrder.vue?vue&type=style&index=0&id=2119a5e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports